import { createAction } from 'redux-act';

export const DYNAMICDATA_SET_DATA = createAction('DYNAMICDATA_SET_DATA');

export const setDynamicData = (dataTopic,data) => dispatch => {
  return dispatch(DYNAMICDATA_SET_DATA({ dataTopic, data }));
};